import React, { useState, useEffect } from "react";
import { ReactComponent as SunIcon } from "../assets/sun-2.svg";
import { ReactComponent as MoonIcon } from "../assets/moon-stars.svg";

const SunMoon = () => {
  const [isMoonVisible, setMoonVisible] = useState(false); // Start with dark theme (moon hidden)

  // Al montar el componente, verifica la preferencia del usuario
  useEffect(() => {
    // Default to dark theme unless explicitly set to light
    if (localStorage.getItem('theme') === 'light') {
      setMoonVisible(true);
      document.body.classList.remove('dark-theme');
    } else {
      // Default dark theme
      setMoonVisible(false);
      document.body.classList.add('dark-theme');
      if (!localStorage.getItem('theme')) {
        localStorage.setItem('theme', 'dark'); // Save default preference only if not set
      }
    }
  }, []);

  const toggleSunMoon = () => {
    setMoonVisible(!isMoonVisible);
    document.body.classList.toggle('dark-theme');

    if (document.body.classList.contains('dark-theme')) {
      localStorage.setItem('theme', 'dark');
    } else {
      localStorage.setItem('theme', 'light'); // Always save user preference
    }
  };

    return (
      <div onClick={toggleSunMoon} style={{ cursor: "pointer" }}>
          {isMoonVisible ? (
              <div className="moon">
                  <MoonIcon />
              </div>
          ) : (
              <div className="sun">
                  <SunIcon />
              </div>
          )}
      </div>
  );
};

export default SunMoon;